import React, { Component } from 'react';
import './index.scss';

import Grid from 'material-ui/Grid';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';


import { withStyles } from 'material-ui/styles';
import {observer,inject} from 'mobx-react';

const styles = theme => ({
    textFieldInput : {
        fontSize : 15,
        fontFamily: 'Kanit-Light',
        textAlign: 'right',
    },
    textFieldFormLabel : {
        fontSize : 14,
        color: '#FAFAFA'
    },
    text: {
        fontSize : 14
    },
    button: {
        // margin: 10,
        marginTop: 15,
        padding: 0,
        // minWidth: 30,
        minWidth: "23px",
        width: "100%",
        maxWidth: "30px",
        minHeight: 20,
        lineHeight: 1.5,
        // paddingBottom: 10,
        fontSize : 15,
        border: 'solid 1px #BDBDBD' ,
    },
    applianceText: {
        // margin: 10,
        fontSize : 15,
        fontFamily: 'Kanit-Light',
        // textAlign: 'right',
        textAlign: 'center',
    }
});

@inject("summaryDataStore")
@observer
class HomeAppliance extends Component {

    constructor(props){
        super(props)
        this.state = {
            appliance: 0,
            appliance1: 0,
            appliance2: 0,
            appliance3: 0,
            appliance4: 0,
            appliance5: 0,
            appliance6: 0,
            appliance7: 0,
            appliance8: 0,
            appliance9: 0,
            appliance10: 0,
        }
    }

    componentDidMount() {
        const { homeAppliance } = this.props.summaryDataStore;
        homeAppliance.map((data, key)=> {
            switch (key){
                case 0:
                    this.setState({ appliance: data.number})
                    break;
                case 1:
                    this.setState({ appliance1: data.number})
                    break;
                case 2:
                    this.setState({ appliance2: data.number})
                    break;
                case 3:
                    this.setState({ appliance3: data.number})
                    break;
                case 4:
                    this.setState({ appliance4: data.number})
                    break;
                case 5:
                    this.setState({ appliance5: data.number})
                    break;
                case 6:
                    this.setState({ appliance6: data.number})
                    break;
                case 7:
                    this.setState({ appliance7: data.number})
                    break;
                case 8:
                    this.setState({ appliance8: data.number})
                    break;
                case 9:
                    this.setState({ appliance9: data.number})
                    break;
                case 10:
                    this.setState({ appliance10: data.number})
                    break;
                default:
            }
        })
    }

    handleChange = event => {
        switch (event.target.id){
            case '0':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance: event.target.value})
                break;
            case '1':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance1: event.target.value})
                break;
            case '2':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance2: event.target.value})
                break;
            case '3':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance3: event.target.value})
                break;
            case '4':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance4: event.target.value})
                break;
            case '5':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance5: event.target.value})
                break;
            case '6':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance6: event.target.value})
                break;
            case '7':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance7: event.target.value})
                break;
            case '8':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance8: event.target.value})
                break;
            case '9':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance9: event.target.value})
                break;
            case '10':
                this.props.summaryDataStore.setHomeApplianceNumber(event.target.id,event.target.value)
                this.setState({ appliance10: event.target.value})
                break;
            default:
        }
    };

    handleMinusChange = id => {
       let minValue = 1
        switch (id) {
            case 0:
                var value = this.state.appliance -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('0',value);
                this.setState({ appliance: value})
                break;
            case 1:
                var value = this.state.appliance1 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('1',value);
                this.setState({ appliance1: value})
                break;
            case 2:
                var value = this.state.appliance2 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('2',value);
                this.setState({ appliance2: value})
                break;
            case 3:
                var value = this.state.appliance3 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('3',value);
                this.setState({ appliance3: value})
                break;
            case 4:
                var value = this.state.appliance4 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('4',value);
                this.setState({ appliance4: value})
                break;
            case 5:
                var value = this.state.appliance5 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('5',value);
                this.setState({ appliance5: value})
                break;
            case 6:
                var value = this.state.appliance6 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('6',value);
                this.setState({ appliance6: value})
                break;
            case 7:
                var value = this.state.appliance7 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('7',value);
                this.setState({ appliance7: value})
                break;
            case 8:
                var value = this.state.appliance8 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('8',value);
                this.setState({ appliance8: value})
                break;
            case 9:
                var value = this.state.appliance9 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('9',value);
                this.setState({ appliance9: value})
                break;
            case 10:
                var value = this.state.appliance10 -1;
                if (value < minValue) {
                    value = minValue;
                    return
                }
                this.props.summaryDataStore.setHomeApplianceNumber('10',value);
                this.setState({ appliance10: value})
                break;
            default:
        }
        return true;
    };

    handleAddChange = id => {
        switch (id) {
            case 0:
                var value = this.state.appliance + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('0',value);
                this.setState({ appliance: value})
                break;
            case 1:
                var value = this.state.appliance1 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('1',value);
                this.setState({ appliance1: value})
                break;
            case 2:
                var value = this.state.appliance2 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('2',value);
                this.setState({ appliance2: value})
                break;
            case 3:
                var value = this.state.appliance3 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('3',value);
                this.setState({ appliance3: value})
                break;
            case 4:
                var value = this.state.appliance4 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('4',value);
                this.setState({ appliance4: value})
                break;
            case 5:
                var value = this.state.appliance5 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('5',value);
                this.setState({ appliance5: value})
                break;
            case 6:
                var value = this.state.appliance6 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('6',value);
                this.setState({ appliance6: value})
                break;
            case 7:
                var value = this.state.appliance7 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('7',value);
                this.setState({ appliance7: value})
                break;
            case 8:
                var value = this.state.appliance8 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('8',value);
                this.setState({ appliance8: value})
                break;
            case 9:
                var value = this.state.appliance9 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('9',value);
                this.setState({ appliance9: value})
                break;
            case 10:
                var value = this.state.appliance10 + 1;
                this.props.summaryDataStore.setHomeApplianceNumber('10',value);
                this.setState({ appliance10: value})
                break;
            default:
        }
    };

    _renderHomeAppliance(id,iconUrl,number,powerConsume,title) {
        const { appliance, appliance1, appliance2, appliance3, appliance4, appliance5, appliance6  } = this.state;
        const { classes } = this.props;
        title += ' ('+powerConsume+' วัตต์)';
        switch (id){
            case 0:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                                <p style={{textAlign: 'left'}} >{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 1:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'>  */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance1}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle'> */}
                                <p style={{textAlign: 'left'}} >{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 2:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance2}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle'> */}
                                <p style={{textAlign: 'left'}}>{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 3:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance3}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle' > */}
                                <p style={{textAlign: 'left'}}>{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 4:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance4}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle'> */}
                                <p style={{textAlign: 'left'}}>{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 5:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance5}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle'> */}
                                <p style={{textAlign: 'left'}}>{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            case 6:
                return (
                    <Grid xs={6} sm={6} md={6} key={id}>
                        <Grid container className='containerGrid' spacing={0}>
                            {/*<Grid xs={1} sm={1} md={1}></Grid>*/}
                            <Grid xs={3} sm={3} md={3} className='ApplianceImg'>
                                <img src={iconUrl} alt='icon' className='iconUrl' />
                            </Grid>
                            <Grid xs={9} sm={9} md={9} className='ApplianceInput'>
                            {/* <Grid xs={5} sm={5} md={5} className='ApplianceInput'> */}
                                <FormControl className='inputLeftZone'>
                                    <div>
                                        <Grid container className='' spacing={0}>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'minus_' + id} className={classes.button}  value="adaf" onClick={() => this.handleMinusChange(id)}>-</Button>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <p className={classes.applianceText} >{appliance6}</p>
                                            </Grid>
                                            <Grid xs={4} sm={4} md={4}>
                                                <Button id={'add_' + id} className={classes.button} aria-label="Add" onClick={() => this.handleAddChange(id)}>+</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </FormControl>
                            </Grid>
                            {/*<Grid xs={2} sm={2} md={2}></Grid>*/}
                            <Grid xs={12} sm={12} md={12} className='ApplianceTitle'>
                            {/* <Grid xs={10} sm={10} md={10} className='ApplianceTitle'> */}
                                <p style={{textAlign: 'left'}}>{title}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            default:
        }
    }

    render() {
        const { homeAppliance } = this.props.summaryDataStore;
        return (
            <div className='HomeAppliance' >
                <Grid container className='containerGrid' spacing={0}>
                    {
                        homeAppliance.map((data, key)=> {
                            return this._renderHomeAppliance(key,data.iconUrl,data.number,data.powerConsume,data.title)
                        })
                    }
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(HomeAppliance);


// WEBPACK FOOTER //
// ./src/components/accessories/homeAppliance.js